export default __webpack_public_path__ + "static/media/icAlbanianFlag.29827cf7.png";